module.exports = __webpack_public_path__ + "img/heating-type-02-label-es.asset.fe05b404.svg";